function get_deal_color_arr_1(xAxis_data, colorArr) {
	// 处理 X轴 无数据
	if (!xAxis_data || xAxis_data.length == 0) {
		console.log('参数错误 - get_line_visual_map_pieces_1')
		return [];
	}

	// 处理颜色数组
	if (colorArr && colorArr.length > 0) {

	} else {
		colorArr = [];
		for (let i = 0; i < xAxis_data.length; i++) {
			colorArr.push(0);
		}
	}

	return colorArr;
}


/**
 * 获取折线图 VisualMap Pieces
 * @param {*} xAxis_data X轴
 * @param {*} colorArr 颜色数组 0-蓝色 1-红色
 * 备注
 * 	1.最后一个点颜色与前面不一样
 *  2.最后一个点变大
 */
function get_line_visual_map_pieces_0(xAxis_data, colorArr) {

	// 处理 X轴 无数据
	if (!xAxis_data || xAxis_data.length == 0) {
		console.log('参数错误 - get_line_visual_map_pieces_1')
		return [];
	}

	// 处理颜色数组
	if (colorArr && colorArr.length > 0) {

	} else {
		colorArr = [];
		for (let i = 0; i < xAxis_data.length; i++) {
			colorArr.push(0);
		}
	}

	// pieces
	let pieces = [];
	for (let i = 0; i < colorArr.length; i++) {
		let needColor;
		if (colorArr[i] == 1) {
			needColor = 'rgba(252, 198, 206, 1)'
		} else if (colorArr[i] == 2) {
			needColor = 'rgba(154, 181, 241, 1)'
		} else {
			needColor = 'rgba(165, 169, 188, 1)'
		}
		if (i == colorArr.length - 1) {
			if (colorArr[i] == 1) {
				needColor = 'rgba(252, 198, 206, 1)'
			} else if (colorArr[i] == 2) {
				needColor = 'rgba(74, 124, 232, 1)'
			} else {
				needColor = 'rgba(165, 169, 188, 1)'
			}
		}
		let piecesItem = {
			gt: i - 1,
			lte: i,
			color: needColor,
			symbolSize: 7.5,
		}
		pieces.push(piecesItem)
	}

	return pieces;
}

/**
 * 获取折线图 VisualMap Pieces
 * @param {*} xAxis_data X轴
 * @param {*} colorArr 颜色数组 0-蓝色 1-红色
 * 备注
 * 	1.最后一个点颜色与前面不一样
 *  2.最后一个点变大
 */
function get_line_visual_map_pieces_0_0(xAxis_data, colorArr, selectIndex) {

	// 处理 X轴 无数据
	if (!xAxis_data || xAxis_data.length == 0) {
		console.log('参数错误 - get_line_visual_map_pieces_1')
		return [];
	}

	// 处理颜色数组
	if (colorArr && colorArr.length > 0) {

	} else {
		colorArr = [];
		for (let i = 0; i < xAxis_data.length; i++) {
			colorArr.push(0);
		}
	}

	// pieces
	let pieces = [];
	for (let i = 0; i < colorArr.length; i++) {
		let needColor;
		if (colorArr[i] == 1) {
			needColor = 'rgba(252, 198, 206, 1)'
		} else if (colorArr[i] == 2) {
			needColor = 'rgba(154, 181, 241, 1)'
		} else {
			needColor = 'rgba(165, 169, 188, 1)'
		}
		if (i == colorArr.length - 1) {
			if (colorArr[i] == 1) {
				needColor = 'rgba(253, 175, 187, 1)'
			} else if (colorArr[i] == 2) {
				needColor = 'rgba(154, 181, 241, 1)'
			} else {
				needColor = 'rgba(165, 169, 188, 1)'
			}
		}
		let piecesItem;
		if (i != selectIndex) {
			piecesItem = {
				gt: i - 1,
				lte: i,
				color: needColor,
				symbolSize: 7.5,
			}
		} else {
			piecesItem = {
				gt: i - 1,
				lte: i,
				color: needColor,
				symbolSize: 7.5,
			}
		}
		pieces.push(piecesItem)
	}

	return pieces;
}

/**
 * 获取折线图 VisualMap Pieces
 * @param {*} xAxis_data X轴
 * @param {*} colorArr 颜色数组 0-蓝色 1-红色
 * 备注
 * 	1.最后一个点颜色与前面不一样
 *  2.最后一个点变大
 */
function get_line_visual_map_pieces_0_1(xAxis_data, colorArr, selectIndex) {

	// 处理 X轴 无数据
	if (!xAxis_data || xAxis_data.length == 0) {
		console.log('参数错误 - get_line_visual_map_pieces_1')
		return [];
	}

	// 处理颜色数组
	if (colorArr && colorArr.length > 0) {

	} else {
		colorArr = [];
		for (let i = 0; i < xAxis_data.length; i++) {
			colorArr.push(0);
		}
	}

	// pieces
	let pieces = [];
	for (let i = 0; i < colorArr.length; i++) {
		let needColor;
		if (colorArr[i] == 1) {
			needColor = 'rgba(252, 252, 253, 1)'
		} else if (colorArr[i] == 2) {
			needColor = 'rgba(74, 124, 232, 1)'
		} else {
			needColor = 'rgba(165, 169, 188, 1)'
		}

		let piecesItem;
		if (i != selectIndex) {
			piecesItem = {
				gt: i - 1,
				lte: i,
				color: '#FFFFFF00',
				symbolSize: 7.5,
			}
		} else {
			piecesItem = {
				gt: i - 1,
				lte: i,
				color: needColor,
				symbolSize: 10,
			}
		}
		pieces.push(piecesItem)
	}

	return pieces;
}



/**
 * 获取折线图 VisualMap Pieces
 * @param {*} xAxis_data X轴
 * @param {*} colorArr 颜色数组 0-蓝色 1-红色
 * 备注
 * 	1.最后一个点颜色与前面不一样
 *  2.最后一个点变大
 */
function get_line_visual_map_pieces_1(xAxis_data, colorArr) {

	// 处理 X轴 无数据
	if (!xAxis_data || xAxis_data.length == 0) {
		console.log('参数错误 - get_line_visual_map_pieces_1')
		return [];
	}

	// 处理颜色数组
	if (colorArr && colorArr.length > 0) {

	} else {
		colorArr = [];
		for (let i = 0; i < xAxis_data.length; i++) {
			colorArr.push(0);
		}
	}

	// pieces
	let pieces = [];
	for (let i = 0; i < colorArr.length; i++) {
		let needColor = colorArr[i] == 1 ? 'rgba(253, 175, 187, 1)' : 'rgba(154, 181, 241, 1)';
		if (i == colorArr.length - 1) {
			needColor = colorArr[i] == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(74, 124, 232, 1)';
		}
		let piecesItem = {
			gt: i - 1,
			lte: i,
			color: needColor,
			symbolSize: i == colorArr.length - 1 ? 16 : 7.5,
		}
		pieces.push(piecesItem)
	}

	return pieces;
}

/**
 * 获取折线图 VisualMap Pieces
 * @param {*} xAxis_data X轴
 * @param {*} colorArr 颜色数组 0-蓝色 1-红色
 * 备注
 * 	1.最后一个点颜色与前面一样
 *  2.最后一个点不变大
 */
function get_line_visual_map_pieces_2(xAxis_data, colorArr) {

	// 处理 X轴 无数据
	if (!xAxis_data || xAxis_data.length == 0) {
		console.log('参数错误 - get_line_visual_map_pieces_2')
		return [];
	}

	// 处理颜色数组
	if (colorArr && colorArr.length > 0) {

	} else {
		colorArr = [];
		for (let i = 0; i < xAxis_data.length; i++) {
			colorArr.push(0);
		}
	}

	// pieces
	let pieces = [];
	for (let i = 0; i < colorArr.length; i++) {
		let needColor = colorArr[i] == 1 ? 'rgba(253, 175, 187, 1)' : 'rgba(154, 181, 241, 1)';
		let piecesItem = {
			gt: i - 1,
			lte: i,
			color: needColor,
			symbolSize: 7.5,
		}
		pieces.push(piecesItem)
	}

	return pieces;
}

/**
 * 获取折线图 VisualMap Pieces
 * @param {*} xAxis_data X轴
 * @param {*} colorArr 颜色数组 0-蓝色 1-红色
 * 备注
 * 	1.最后一个点颜色与前面不一样
 *  2.最后一个点变大
 */
function get_line_visual_map_pieces_3(xAxis_data, colorArr) {

	// 处理 X轴 无数据
	if (!xAxis_data || xAxis_data.length == 0) {
		console.log('参数错误 - get_line_visual_map_pieces_1')
		return [];
	}

	// 处理颜色数组
	if (colorArr && colorArr.length > 0) {

	} else {
		colorArr = [];
		for (let i = 0; i < xAxis_data.length; i++) {
			colorArr.push(0);
		}
	}

	// pieces
	let pieces = [];
	for (let i = 0; i < colorArr.length; i++) {
		let needColor = colorArr[i] == 1 ? 'rgba(253, 175, 187, 1)' : 'rgba(154, 181, 241, 1)';
		if (i == colorArr.length - 1) {
			needColor = colorArr[i] == 1 ? 'rgba(252, 198, 206, 1)' : 'rgba(74, 124, 232, 1)';
		}
		let piecesItem = {
			gt: i - 1,
			lte: i,
			color: needColor,
			symbolSize: i == colorArr.length - 1 ? 10 : 7.5,
		}
		pieces.push(piecesItem)
	}

	return pieces;
}

/**
 * 获取折线图 VisualMap Pieces
 * @param {*} xAxis_data X轴
 * @param {*} colorArr 颜色数组 0-蓝色 1-红色
 * 备注
 * 	1.最后一个点颜色与前面一样
 *  2.最后一个点不变大
 */
function get_line_visual_map_pieces_4(xAxis_data, colorArr) {

	// 处理 X轴 无数据
	if (!xAxis_data || xAxis_data.length == 0) {
		console.log('参数错误 - get_line_visual_map_pieces_2')
		return [];
	}

	// 处理颜色数组
	if (colorArr && colorArr.length > 0) {

	} else {
		colorArr = [];
		for (let i = 0; i < xAxis_data.length; i++) {
			colorArr.push(0);
		}
	}

	// pieces
	let pieces = [];
	for (let i = 0; i < colorArr.length; i++) {
		let needColor = colorArr[i] == 1 ? 'rgba(253, 175, 187, 1)' : 'rgba(154, 181, 241, 1)';
		let piecesItem = {
			gt: i - 1,
			lte: i,
			color: needColor,
			symbolSize: 7.5,
		}
		pieces.push(piecesItem)
	}

	return pieces;
}

/**
 * 获取折线图 VisualMap Pieces
 * @param {*} xAxis_data X轴
 * @param {*} colorArr 颜色数组 0-蓝色 1-红色
 * 备注
 * 	1.最后一个点颜色与前面不一样
 *  2.最后一个点变大
 */
function get_line_visual_map_pieces_5(xAxis_data, colorArr) {

	// 处理 X轴 无数据
	if (!xAxis_data || xAxis_data.length == 0) {
		console.log('参数错误 - get_line_visual_map_pieces_1')
		return [];
	}

	// 处理颜色数组
	if (colorArr && colorArr.length > 0) {

	} else {
		colorArr = [];
		for (let i = 0; i < xAxis_data.length; i++) {
			colorArr.push(0);
		}
	}

	// pieces
	let pieces = [];
	for (let i = 0; i < colorArr.length; i++) {
		let needColor = colorArr[i] == 1 ? 'rgba(253, 175, 187, 1)' : 'rgba(154, 181, 241, 1)';
		if (i == colorArr.length - 1) {
			needColor = colorArr[i] == 1 ? 'rgba(252, 198, 206, 1)' : 'rgba(74, 124, 232, 1)';
		}
		let piecesItem = {
			gt: i - 1,
			lte: i,
			color: needColor,
			symbolSize: i == colorArr.length - 1 ? 10 : 7.5,
		}
		pieces.push(piecesItem)
	}

	return pieces;
}

/**
 * 获取折线图 VisualMap Pieces
 * @param {*} xAxis_data X轴
 * @param {*} colorArr 颜色数组 0-蓝色 1-红色
 * 备注
 * 	1.最后一个点颜色与前面一样
 *  2.最后一个点不变大
 */
function get_line_visual_map_pieces_6(xAxis_data, colorArr) {

	// 处理 X轴 无数据
	if (!xAxis_data || xAxis_data.length == 0) {
		console.log('参数错误 - get_line_visual_map_pieces_2')
		return [];
	}

	// 处理颜色数组
	if (colorArr && colorArr.length > 0) {

	} else {
		colorArr = [];
		for (let i = 0; i < xAxis_data.length; i++) {
			colorArr.push(0);
		}
	}

	// pieces
	let pieces = [];
	for (let i = 0; i < colorArr.length; i++) {
		let needColor = colorArr[i] == 1 ? 'rgba(253, 175, 187, 1)' : 'rgba(154, 181, 241, 1)';
		let piecesItem = {
			gt: i - 1,
			lte: i,
			color: needColor,
			symbolSize: 7.5,
		}
		pieces.push(piecesItem)
	}

	return pieces;
}

/**
 * 获取折线图 VisualMap Pieces
 * @param {*} xAxis_data X轴
 * @param {*} colorArr 颜色数组 0-蓝色 1-红色
 * 备注
 * 	1.最后一个点颜色与前面不一样
 *  2.最后一个点变大
 */
function get_line_visual_map_pieces_10(xAxis_data, colorTypeArr) {

	// 处理 X轴 无数据
	if (!xAxis_data || xAxis_data.length == 0) {
		console.log('参数错误 - get_line_visual_map_pieces_1')
		return [];
	}

	// 处理颜色数组
	if (colorTypeArr && colorTypeArr.length > 0) {

	} else {
		colorTypeArr = [];
		for (let i = 0; i < xAxis_data.length; i++) {
			colorTypeArr.push(1);
		}
	}

	let tempMin = 7.5;
	let tempMax = 10;
	if (colorTypeArr.length > 30) {
		tempMin = 4.5;
		tempMax = 6;
	}

	// pieces
	let pieces = [];
	for (let i = 0; i < colorTypeArr.length; i++) {
		let needColor;
		if (colorTypeArr[i] == 1) {
			needColor = 'rgba(154, 181, 241, 1)';
		} else if (colorTypeArr[i] == 2) {
			needColor = 'rgba(154, 181, 241, 1)'
		} else if (colorTypeArr[i] == 3) {
			needColor = 'rgba(253, 175, 187, 1)'
		} else {
			needColor = 'rgba(252, 198, 206, 1)'
		}
		let piecesItem = {
			gt: i - 1,
			lte: i,
			color: needColor,
			symbolSize: colorTypeArr[i] == 4 ? tempMax :tempMin,
		}
		pieces.push(piecesItem)
	}

	return pieces;
}


export default {
	get_deal_color_arr_1,
	get_line_visual_map_pieces_0,
	get_line_visual_map_pieces_1,
	get_line_visual_map_pieces_2,
	get_line_visual_map_pieces_3,
	get_line_visual_map_pieces_4,
	get_line_visual_map_pieces_5,
	get_line_visual_map_pieces_6,
	get_line_visual_map_pieces_10,
	get_line_visual_map_pieces_0_0,
	get_line_visual_map_pieces_0_1
}